






























































































































































































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import store from "@/store";
import _ from "underscore";
//  @types
import { ExtendedVessel } from "@/types/vessel";
//  @modules
import { getModule } from "vuex-module-decorators";
import SnackbarModule from "@/store/clients/Snackbar.module";
import VesselsModule from "@/store/clients/Vessels.module";

const Snackbar = getModule(SnackbarModule, store);
const Vessels = getModule(VesselsModule, store);

@Component({})
export default class CustomAlertDialog extends Vue {
  @PropSync("value", { required: true, type: Boolean, default: false }) isModalActive!: boolean;
  @Prop({ type: String, default: "670px" }) width!: string;
  @Prop({ required: true }) readonly vessels!: ExtendedVessel[];

  // @Data
  typeList: string[] = ["Logical", "Mathematical"];
  type: string = this.typeList[0];
  selectedVessels: ExtendedVessel[] = this.vessels.length > 0 ? JSON.parse(JSON.stringify(this.vessels)) : [];
  searchVesselQuery: string = "";
  VesselSelectMenu: boolean = false;

  //  @Getters
  get formattedVesselSelectionResult(): string {
    const isAllSelected = this.selectedVessels.length === this.vessels.length;

    if (!isAllSelected) return `Vessels (${this.selectedVessels.length})`;
    return `All Selected Vessels`;
  }

  get isAllVesselsSelected(): boolean {
    return this.vessels.length > 0 && this.vessels.every(vessel => this.selectedVessels.some(sel => sel.id === vessel.id));
  }
  set isAllVesselsSelected(value: boolean) {
    if (value) {
      // Select all enabled vessels
      const toAdd = this.vessels.filter(vessel => !this.selectedVessels.some(sel => sel.id === vessel.id));
      this.selectedVessels.push(...toAdd);
    } else {
      // Unselect all enabled vessels
      this.selectedVessels = this.selectedVessels.filter(vessel => !this.vessels.some(sel => sel.id === vessel.id));
    }
  }

  //  @Methods
  onSelectAll($event: boolean): void {
    this.selectedVessels = $event ? [...this.vessels] : [];
  }

  close(): void {
    this.isModalActive = false;
  }

  //  @Hooks
  mounted(): void {
    this.selectedVessels = this.vessels.length > 0 ? JSON.parse(JSON.stringify(this.vessels)) : [];
  }
}
